import { createApp } from '@neos/app'
import { views } from './views'
import { menuItems } from './menuItems'
import images from './images'
import Notifications from './Notifications'
import '@neos/design-system/dist/design-system.css'
import '@neos/app/dist/app.css'
import '@neos/ai/dist/ai.css'
import '@neos/rich-text-editor/dist/rich-text-editor.css'

const resources = import.meta.glob<boolean, string, { default: Record<string, unknown> }>('./resources/*.ts')

const themes = import.meta.glob<boolean, string, string | undefined>('./themes/*.css', {
  query: '?inline',
  import: 'default',
})

createApp({
  production: import.meta.env.PROD,
  devBaseUrl: import.meta.env.DEV ? import.meta.env.BASE_URL : undefined,
  name: 'TMSVirTracking',
  version: '1.1.0-build.9',
  title: 'TrackingTMSVIR',
  company: 'Akanea',
  languages: ['en', 'fr'],
  importResources: (lang) => resources[`./resources/${lang}.ts`],
  importNotifications: (connection) => new Notifications(connection),
  images,
  themes: [{ name: 'NeosV1', colorScheme: 'light', animatedButtons: false, buttonsLayoutReverseOrder: false }, { name: 'NeosV2', colorScheme: 'light', animatedButtons: false, buttonsLayoutReverseOrder: false }, { name: 'NeosV3', colorScheme: 'light', animatedButtons: true, buttonsLayoutReverseOrder: false }, { name: 'NeosV3Dark', colorScheme: 'dark', animatedButtons: true, buttonsLayoutReverseOrder: false }, { name: 'VIR', colorScheme: 'light', animatedButtons: false, buttonsLayoutReverseOrder: false }],
  importTheme: (theme) => themes[`./themes/${theme}.css`]?.(),
  hotModuleReload: import.meta.hot,
  views,
  menuItems,
  initializationMethods: [],
  mainUIViewName: 'MroadOrderUI',
  mainFramesContainerId: 'HomePageFrameContainer',
  uiDefaultBehavior: {},
})